<template>
  <div>
    <!-- NOVO: Alert quando Contrato Social foi alterado -->
    <v-alert 
      v-if="mostrarAlertaContratoSocial && isAlteracao && acaoTela === 'alterar'"
      type="warning"
      outlined
      prominent
      class="ma-4 mb-6"
      border="left"
    >
      <v-row align="center">
        <v-col class="grow">
          <div class="font-weight-black text-h6">⚠️ ATUALIZAÇÃO NECESSÁRIA</div>
          <div class="mt-2">
            O <strong>Contrato Social</strong> foi alterado na aba "Habilitação Jurídica". 
            É necessário <strong>atualizar o Cartão CNPJ</strong> abaixo para prosseguir:
          </div>
        </v-col>
        <v-col class="shrink">
          <v-btn
            color="primary"
            @click="scrollToCartaoCNPJ"
            small
          >
            <v-icon left>arrow_downward</v-icon>
            Ir para Cartão CNPJ
          </v-btn>
        </v-col>
      </v-row>
    </v-alert>
    <v-flex>
      <div class="p-t-30 boxFamilias" :key="regFiscalKey">
        
        <div v-for="item in enums.tipoDocumento" :key="item.chave+''+item.valor">
          <v-layout row wrap class v-if="mostrarBox(item.chave)" p-b-20>
           
            <v-flex xs12>              
              <v-card 
                class="card--flex-toolbar"
                :class="{ 'cartao-cnpj-destaque': item.chave === 'CNPJ' && mostrarAlertaContratoSocial }"
                :data-documento="item.chave"
              >
                
              
                <v-toolbar light :class="{'item-reprovado':verificaErro(hasError,item.chave)}">
                  <v-toolbar-title>
                    <strong v-if="obrigatoriedadeDocumento(item.chave)">{{item.descricao + testeAstericoEstrangeiro(item.chave)}} </strong>
                    <strong v-else>{{item.descricao}} </strong>
                  </v-toolbar-title>                  

                  <!-- Mensagens personalizadas no botão de info -->
                 <v-menu v-if="item.chave === 'ContribuinteMunicipalServicos'">
                  
                        <template slot="activator">
                          <v-icon color="primary" style="margin-top:-6px" light>info</v-icon>
                        </template>
					                <v-card class="boxInfoDoc">
                          <v-card-title>
                            <strong> Alvará de Funcionamento Municipal ou Ficha de Inscrição Municipal</strong>
                          </v-card-title>                          
                        </v-card>
                    </v-menu> 
                    <v-menu v-if="item.chave === 'EstadualBA'">
                        <template slot="activator">
                          <v-icon color="primary" style="margin-top:-6px" light>info</v-icon>
                        </template>
  				                <v-card class="boxInfoDoc">
                          <v-card-title>
                            <strong>  Regularidade com a Fazenda Estadual da Bahia. Emitida no Portal
                      <a href="https://www.sefaz.ba.gov.br/" target="_blank">https://www.sefaz.ba.gov.br/</a>.</strong>
                          </v-card-title>                          
                        </v-card>
                    </v-menu> 
                  <!-- / Mensagens personalizadas no botão de info -->                  
                 
                  <v-spacer></v-spacer>
                  <v-btn icon @click="openBox(item)">
                    <v-icon color="primary">unfold_more</v-icon>
                  </v-btn>
                </v-toolbar>
                <v-layout row wrap v-show="isShow[item.chave+''+item.valor]">
                  <v-flex xs6 sm6 v-show="isAlteracao" class="red--text">
                  <strong>   Para conseguir editar informações é preciso clicar no lapis à esquerda.</strong>
                </v-flex><br>
                  <v-flex xs12 sm12 v-show="isAlteracao">
                   
                    <v-tooltip midle sm5>
                      <v-btn slot="activator" icon @click="editarRegularidade(item.chave)">
                       
                        <v-icon color="grey">edit</v-icon>
                      </v-btn>
                      <span>Editar</span>
                    </v-tooltip>
                  </v-flex>
                  <v-flex sm6 v-bind:class="{'xs10':isAlteracao,'xs12':!isAlteracao}">
                    <v-text-field
                      v-model="tipoDocumento[item.chave]['numDocumento']"
                      :label="labelNumDocumento(item.chave) + testeAstericoEstrangeiro(item.chave)"
                      :rules="obrigatoriedadeDocumento(item.chave) ? ( (item.chave == 'CNPJ') ? validaIfObrigatorio().concat(validacao.cnpj) : validaIfObrigatorio(true) ) : []"
                      :required="(!isAlteracao || (isAlteracao && !tipoDocumento[item.chave]['arquivoUpload'])) "
                      validate-on-blur
                      :readonly="validaReadonly(item.chave,'numDocumento')"
                      maxlength="30"
                      v-mask="(item.chave == 'CNPJ')  ? maskCnpj : maskAnyChar"
                      @change="alteracaoValorCampo(tipoDocumento[item.chave])"
                      :ref="`text_${item.chave}`"
                    ></v-text-field>
                  </v-flex>
                  <v-flex  v-if="exibeCampo(item.chave,'situacaoDoc')" xs12 v-bind:class="{'sm5':isAlteracao,'sm6':!isAlteracao}">
                    <v-select
                      v-model="tipoDocumento[item.chave]['situacaoDoc']"
                      :items="getSituacaoPorDoc(item.chave)"
                      :label="$t('label.situacao')+testeAstericoEstrangeiro(item.chave)"
                      :persistent-hint ="true" 
                      item-text="descricao"
                      item-value="valor"
                      :return-object="false"
                      :key="tipoDocumento[item.chave]['situacaoDoc']+'_1'"
                      :rules="obrigatoriedadeDocumento(item.chave) ? validaIfObrigatorio() : []"
                      validate-on-blur
                      :readonly="validaReadonly(item.chave)"
                      @change="alteracaoValorCampo(tipoDocumento[item.chave])"
                      :ref="`select_${item.chave}`"
                    ></v-select>
                  </v-flex>

                  <v-flex xs6 sm4 md3 v-if="exibeCampo(item.chave,'dtEmissao')">
                    <datePicker
                      v-model="tipoDocumento[item.chave]['dtEmissao']"
                      :dataDefault="tipoDocumento[item.chave]['dtEmissao']"
                      v-mask="maskData"
                      :key="dtEmissaoKey"
                      :limitarData="true"
                      :rules="(obrigatoriedadeDocumento(item.chave) ? (validaIfObrigatorio(( (!isAlteracao || (isAlteracao && !tipoDocumento[item.chave]['arquivoUpload'])))).concat([v=>validaDataInvalida(v,((!isAlteracao || (isAlteracao && !tipoDocumento[item.chave]['arquivoUpload'])))) || 'Data Inválida'])) : [])" 
                      :label="$t('label.dataEmissao') +testeAstericoEstrangeiro(item.chave)"                      
                      validate-on-blur
                      :bloquearData="validaReadonly(item.chave)"
                      @change="alteracaoValorCampo(tipoDocumento[item.chave])"
                      :ref="`date_${item.chave}`"
                    />
                  </v-flex>
                  
                  <v-flex xs6 sm4 md3 v-if="exibeCampo(item.chave,'dtVencimento')">
                    <!-- {{ tipoDocumento[item.chave].tipDocumento }} -->
                    <!-- Se tipo de documento for igual a 3 (CADASTRO DE CONTRIBUINTE MUNICIPAL) tira a obrigatoriedade -->
                    <div v-if="tipoDocumento[item.chave].tipDocumento == 3">
                      <datePicker
                        v-model="tipoDocumento[item.chave]['dtVencimento']"
                        :dataDefault="tipoDocumento[item.chave]['dtVencimento']"
                        v-mask="maskData"
                        :key="dtVencimentoKey"    
                        :rules="[
                              v => !v || obrigatoriedadeDocumento(item.chave) || true,
                           ]"
                        :label="$t('label.dataValidade') + testeAstericoEstrangeiro(item.chave)"
                        :required="((!isAlteracao || (isAlteracao && !tipoDocumento[item.chave]['arquivoUpload'])))"
                        :testarDataVencida="validaDataVencida()"
                        validate-on-blur
                        :bloquearData="validaReadonly(item.chave)"
                        :limitarDataVencida="true"
                        @change="alteracaoValorCampo(tipoDocumento[item.chave])"
                        :ref="`date_${item.chave}`"
                      />
                    </div>
                    <div v-else>
                      <datePicker
                        v-model="tipoDocumento[item.chave]['dtVencimento']"
                        :dataDefault="tipoDocumento[item.chave]['dtVencimento']"
                        v-mask="maskData"
                        :key="dtVencimentoKey"
                        :rules="(obrigatoriedadeDocumento(item.chave) ? (validaIfObrigatorio(( (!isAlteracao || (isAlteracao && !tipoDocumento[item.chave]['arquivoUpload'])))).concat([v=>validaDataInvalida(v,((!isAlteracao || (isAlteracao && !tipoDocumento[item.chave]['arquivoUpload'])))) || 'Data Inválida'])) : [])" 
                        :label="$t('label.dataValidade') + testeAstericoEstrangeiro(item.chave)"
                        :required="((!isAlteracao || (isAlteracao && !tipoDocumento[item.chave]['arquivoUpload'])))"
                        :testarDataVencida="validaDataVencida()"
                        validate-on-blur
                        :bloquearData="validaReadonly(item.chave)"
                        :limitarDataVencida="true"
                        @change="alteracaoValorCampo(tipoDocumento[item.chave])"
                        :ref="`date_${item.chave}`"
                      />
                    </div>
                  </v-flex>

                  <v-flex xs12 sm4 md3 v-if="exibeCampo(item.chave,'codControle')">
                    <v-text-field
                      v-model="tipoDocumento[item.chave]['codControle']"
                      :label="$t('label.codDeControle')"
                      :readonly="validaReadonly(item.chave)"
                      maxlength="50"
                      @change="alteracaoValorCampo(tipoDocumento[item.chave])"
                      :ref="`text_${item.chave}`"
                    ></v-text-field>
                  </v-flex>

                  <v-flex inputIcon xs12 sm12 md5 v-show="!tipoDocumento[item.chave]['novoUpload']"
                    v-if="!(isDocIntegradoSimpas(item.valor)) || tipoDocumento[item.chave]['dtVencimento'] == null">
                    <v-text-field
                      :value="subStrUpload(tipoDocumento[item.chave]['arquivoUpload'],item.descricao)"
                      :label="$t('label.anexaDocumento')+ testeAstericoEstrangeiro(item.chave)"
                      clearable
                      :append-icon="isAnexoValido(tipoDocumento[item.chave]) ? 'get_app' : ''"
                      :rules="[isAnexoValido(tipoDocumento[item.chave]) || $t('messages.validacao.documentoInvalido')]"
                      readonly
                      @click:append="baixarArquivo(tipoDocumento[item.chave]['arquivoUpload'])"
                      @click:clear="novoUpload(item.chave); editarRegularidade(item.chave)"
                      :ref="`text_${item.chave}`"
                    ></v-text-field>
                  </v-flex>
                  
                  <v-flex xs12 sm12 md5 v-show="tipoDocumento[item.chave]['novoUpload']" 
                  v-if="(!(isDocIntegradoSimpas(item.valor) && !ifRegularidadeFiscalAlterado(tipoDocumento[item.chave]['tipDocumento'],tipoDocumento[item.chave]['arquivoUpload'],'arquivoUpload')) || tipoDocumento[item.chave]['dtVencimento'] == null)">                    
                    <uploadFile
                      tamanhoMaximo="20MB"
                      :required="(obrigatoriedadeDocumento(item.chave)) && ( (tipoDocumento[item.chave]['novoUpload'] && model.flagEstrangeiro==0))"
                      :label="$t('label.anexaDocumento') + testeAstericoEstrangeiro(item.chave)"
                      v-model="tipoDocumento[item.chave]['file']"
                      accept=".pdf, .PDF"
                      :ref="`upload_${item.chave}`"
                    />
                  </v-flex>
                                    
                  <v-flex xs12 sm12 md4 v-if="item.chave === 'CNPJ' && model.tipFornecedor === 'J' && exibeCampo(item.chave,'dtAberturaEmpresa')">
                    
                    <datePicker
                      v-model="tipoDocumento[item.chave]['dtAberturaEmpresa']"
                      :dataDefault="tipoDocumento[item.chave]['dtAberturaEmpresa']"
                      v-mask="maskData"
                      :key="dtAberturaEmpresaKey"
                      :limitarData="true"
                      :rules="(obrigatoriedadeDocumento(item.chave) ? (validaIfObrigatorio(( (!isAlteracao || (isAlteracao && !tipoDocumento[item.chave]['dtAberturaEmpresa'])))).concat([v=>validaDataInvalida(v,((!isAlteracao || (isAlteracao && !tipoDocumento[item.chave]['dtAberturaEmpresa'])))) || 'Data Inválida'])) : [])"
                      :label="$t('label.dataAberturaEmpresa') +testeAstericoEstrangeiro(item.chave)"                      
                      validate-on-blur                      
                      :bloquearData="validaReadonly(item.chave)"
                      @change="alteracaoValorCampo(tipoDocumento[item.chave])"
                      :ref="`date_${item.chave}`"
                      
                    />

                  </v-flex>

                  <v-flex xs12>
                  <strong class="text-red" 
                    v-if="isDocIntegradoSimpas(item.valor)">
                    Documento atualizado pela integração.
                  </strong>
                </v-flex>

                </v-layout>
              </v-card> 
           
            </v-flex>
          </v-layout>
        </div>
      </div>
    </v-flex>
  </div>
</template>
<script>
import util from "../../plugins/util"; /*Objeto com metodos e funcoes utilizadas pelo sistema */
import fornecedorService from "../../services/fornecedorService"; /*Objeto com os principais servicos de Fornecedor */
import analiseCampoAlterado from "../area-restrita/fornecedor/components/analiseCampoAlterado.vue";
import documentosService from "../../services/documentosFornecService";
export default {
  name: "regularidade-fiscal",
  mixins: [util,analiseCampoAlterado],
  props: {//Propriedades que o objeto recebe como parametro
    model: Object, /*Solicitacao atual do Fornecedor*/
    enums: Object,
    tipoDocumento: Object,
    OldModel: Object,
    isAlteracao: Boolean,
    hasError: Boolean,
    acaoTela: String
  },
  data() {//Declaracao de variaveis
    return {
      isShow: {},
      mostrarMaterial: false,
      mostrarServico: false,
      dtVencimentoKey: 1,
      dtAberturaEmpresaKey: 1,
      dtEmissaoKey: 1,
      regFiscalKey: 1,
      docsNovosOuAlterados: [],
      listaDocsIntegracaoSimpas: [],
      contratoSocialFoiAlterado: false,
    };
  },
mounted: function() {
  this.regFiscalKey++;
  // Garante que o ID esteja disponível caso o created não tenha executado a tempo
  this.garantirIdDisponivel();
},
      created() /*Metodo de start do componente*/{
        //resgate dos dados de regularidade fiscal
        let _true = true;
        this.enums.tipoDocumento.filter(item => {
          var chave = item.chave;

          this.$set(this.isShow, item.chave + "" + item.valor, _true);

          _true = false;

          this.$set(this.tipoDocumento, chave, {
            novoUpload: true,
            tipDocumento: item.valor
          });

          var regularidadeFiscTrab = this.model.regularidadeFiscTrab.find(
            x => x.tipDocumento == item.valor
          );

          if (regularidadeFiscTrab) {
            if (regularidadeFiscTrab.arquivoUpload) {
              regularidadeFiscTrab.novoUpload = false;
            } else {
              regularidadeFiscTrab.novoUpload = true;
            }

            this.$set(this.tipoDocumento, chave, regularidadeFiscTrab);
          }
        });

        if(this.tipoDocumento['CNPJ'] != null && this.model.tipFornecedor === "J"){
          this.tipoDocumento['CNPJ']['numDocumento'] = this.model.numCgcFornecedor;
        }

      let idFornecSolicitacao = 
      (this.model && this.model.idfornec_solicitacao) ||  // ✅ Primeiro: snake_case do banco
      (this.model && this.model.idFornecSolicitacao) ||   // Fallback: camelCase
      (this.model && this.model.id);                      // Último recurso

    if (idFornecSolicitacao) {
      sessionStorage.setItem('idFornecSolicitacao', String(idFornecSolicitacao));  
      
      // 📡 Emite evento para a sidebar saber que o ID está disponível
      this.$root.$emit('id-solicitacao-disponivel', idFornecSolicitacao);
    } else {
      console.warn(' ID NÃO ENCONTRADO no model. Chaves disponíveis:', Object.keys(this.model || {}));
    }

if (idFornecSolicitacao) {
  documentosService.getSituacaoIntegracaoRegularidadeFiscal(idFornecSolicitacao)
    .then(response => {
      this.listaDocsIntegracaoSimpas = response.data;
    });
  }
    // === Escutar eventos ===
    if (this.isAlteracao && this.acaoTela === 'alterar') {
     
      var vm = this;
      this.$root.$on('contratoSocialAlterado', function(data) {
        
        if (data.alterado && data.novaAlteracao) {
          vm.contratoSocialFoiAlterado = true;        
          
          // Scroll suave para alert
          vm.$nextTick(() => {
            if (vm.mostrarAlertaContratoSocial) {
              vm.scrollToCartaoCNPJ();
            }
          });
        }
      });
    } 
  },

  computed: {
    mostrarAlertaContratoSocial() {
      // === NOVA VALIDAÇÃO: APENAS EM PROCESSOS DE ALTERAÇÃO ===
      if (!this.isAlteracao || this.acaoTela !== 'alterar') {
        return false;
      }
      var mostrar = this.contratoSocialFoiAlterado && !this.cartaoCNPJAtualizado();      
      
      return mostrar;
    }
  },

  methods: {//Declaracao de todos os metodos
    garantirIdDisponivel: function() {
  var id = 
    (this.model && this.model.idfornec_solicitacao) ||
    (this.model && this.model.idFornecSolicitacao) ||
    (this.model && this.model.id);
  
  if (id) {
    sessionStorage.setItem('idFornecSolicitacao', String(id));
    this.$root.$emit('id-solicitacao-disponivel', id);
    return id;
  }
  return null;
},
    isDocIntegradoSimpas(codigo, tipoDoc,arquivo,nomeCampo,novoUpload){
    //Verifica se o documento foi possui a integração com o simpas válida

    let docIntegracao = this.listaDocsIntegracaoSimpas.find( doc => doc.codDocumento == codigo);

    let isAlterado = this.ifRegularidadeFiscalAlterado(tipoDoc,arquivo,nomeCampo);

    let novoDocumento = this.ifNovoDocumento('regularidadeFiscTrab',codigo,'tipDocumento');
    //só retorna verdadeiro se o documento tiver integração mas não tiver sido alterado pelo fornecedor
  if (docIntegracao && !isAlterado){
      if(docIntegracao.identUsuario == true){
        return true;
      }
      if (novoDocumento.length>0){
        //Caso exista um novo upload de documento o campo upload deve aparecer na tela do habilitador
        return false;  
      }else if(arquivo == null && novoUpload) {
       //caso seja um novo upload e o não tenha anexo no documento analisado
        return false;  
      } else{
        return true;
      }

    }else {
      return false;
    }
   },
    testeAstericoEstrangeiro(chave) {
      //testar se o documento é obrigatorio
      //Não é obrigatório para estrangeiros, e nem para o documento Contribuinte Estadual
      if (this.model.tipoCertificado === 3 && chave === "ContribuinteMunicipalServicos" && this.model.tipFornecedor === 'F'  ) return "";
      else if (this.model.flagEstrangeiro === '0' && chave !== 'ContribuinteEstadualMaterial') return " *";
      else return " ";
    },
    editarRegularidade(chave) {
      //limpar os dados para edição
      if (this.isAlteracao) {
        if(chave !== 'CNPJ'){
          this.tipoDocumento[chave]["numDocumento"] = null;
        }
        this.tipoDocumento[chave]["situacaoDoc"] = null;
        this.tipoDocumento[chave]["dtEmissao"] = null;
        this.tipoDocumento[chave]["dtAberturaEmpresa"] = null;
        this.tipoDocumento[chave]["dtVencimento"] = null;
        this.tipoDocumento[chave]["codControle"] = null;
        this.tipoDocumento[chave]["arquivoUpload"] = null;
        this.tipoDocumento[chave]["novoUpload"] = true;
        this.dtVencimentoKey++;
        this.dtEmissaoKey++;
        this.dtAberturaEmpresaKey++;
      }
    },

    validaReadonly(chave,campo) {
      //verifica se é pra não editar
      var retorno = false;
      if(chave === 'CNPJ' && campo === "numDocumento") return true; 
      if (this.isAlteracao) {
        if (this.tipoDocumento[chave]["novoUpload"]) {
          return false;
        } else {
          return true;
        }
      }

      return retorno;
    },

    validaDataVencida() {
      //verificar se a data é vencida
      return this.isAlteracao;
    },

    validaIfObrigatorio(validar) {
      //validar se é obrigatorio
      if(validar){
        if (this.model.flagEstrangeiro === '0' ) {
          return this.validacao.campoObrigatorio;
        } else {
          return [];
        }
      }else {
          return [];
      }
    },

    validaDataInvalida(v, validar) {
      //valida se a data é invalida
      
      if(validar){
        if (this.model.flagEstrangeiro === '0') {
          return v.length === 10;
        } else {
          if (v) {
            return v.length === 10;
          } else {
            return true;
          }
        }
      }else{
        return true;
      }
    },

    mostrarBox(chave) {
      //metodo para ver quais documentos devem aparecer em tela
      if (
        (this.model.codUf === "BA" && chave === "EstadualBA" && this.model.flagEstrangeiro !== '1') || // flagEstrangeiro é um tipo string
        (this.model.codUf === "DF" && (chave === "Municipal" || chave==="ContribuinteMunicipalServicos") && this.model.flagEstrangeiro !== '1') ||
        (chave === "RegularidadeComFGTS" && this.model.tipFornecedor === 'F') ||
        this.naoExibeCartaoCNPJ(chave)
        )
      {
        return false;
      }

      return true;
    },

    // #151962 - Remocao de não obrigatoriedade dos documentos RegularidadeComFGTS e Trabalhista para o fornecedor PJ e MEI, agora é obritorio para todos os fornecedores.
    // verificaCNPJMEI(chave){ 
    //   return ((chave === "RegularidadeComFGTS" || chave === "Trabalhista") && this.model.tipFornecedor === 'J' 
    //   && this.model.categoria === "MEI")
    // },

    verificaCertidaoMunicipal(chave){
      return (chave === "Municipal" && (this.model.codUf !== "BA" || this.model.flagEstrangeiro !== '1')); // includes pode não funcionar nos antigos
    },

    verificaCertidaoCamacari(chave){
      return (chave === "CertidaoMunicipalCamacari" &&
        ((this.model.endCidade && this.model.endCidade.indexOf('Camaçari') === -1) || //indexof funciona para procurar string em navegadores IE antigos
        (this.model.endCidade && !this.model.endCidade.includes('Camaçari')) || // includes pode não funcionar nos antigos
        this.model.codUf !== "BA" || this.model.flagEstrangeiro === '1'));
    },

    naoExibeCartaoCNPJ(chave){
      return (chave === "CNPJ" && this.model.tipFornecedor === "F");
    },

    exibeCampo(chave,campo){
      switch(chave){
        case "CNPJ":
          //Exibe somente dtEmissao e numDocumento
          return (campo === "dtEmissao" || campo === "numDocumento" || campo === "dtAberturaEmpresa");
        case "ContribuinteMunicipalServicos":
           return (campo !== "situacaoDoc");
        case "ContribuinteEstadualMaterial":
          //Não exibe situacaoDoc e data de vencimento
          return (campo !== "situacaoDoc" );
        case "RegularidadeComFGTS":
          return (campo !== "situacaoDoc")
        default:
          return true;
      }
    },

    labelNumDocumento(chave){
      if(chave === "CNPJ"){
        return this.$t('label.numeroInscricao');
      }else{
        return this.$t('label.numeroDocumento');
      }
    },

    novoUpload(chave) {
      let teste = Object.assign({}, this.tipoDocumento[chave]);
      teste.novoUpload = true;
      this.$set(this.tipoDocumento, chave, teste);
    },

    baixarArquivo(arquivo) {
      //baixar  documento
      const numCgcFornecedor = this.$verificaPerfilCadastrador()
        ? this.model.numCgcFornecedor.replace(/[\W_]+/g, "")
        : null;
      fornecedorService.baixarArquivo(arquivo, numCgcFornecedor);
    },

    openBox(item) {
      //abrir o documento com o detalhamento
      const flag = this.isShow[item.chave + "" + item.valor];
      this.$set(this.isShow, item.chave + "" + item.valor, !flag);
    },

    isAnexoValido(anexo){
      return (!!anexo['novoUpload'] || (!!anexo['arquivoUpload'] && anexo['arquivoUpload'] !== "Não Encontrado"));
    },

    obrigatoriedadeDocumento(chave){

      //metodo para a não obrigatoriedade de upload alguns documentos 
      if (chave === "ContribuinteEstadualMaterial"){
        return false;
      } else if ((chave === "ContribuinteMunicipalServicos") && (this.model.categoria === 'MEI' || this.model.tipoCertificado === 3)){
        return false;        

      } else if (chave === 'CNPJ' && this.model.flagEstrangeiro === '1'){
        return false;        
      } 
      else if (this.model.tipoCertificado === 3 && chave === "ContribuinteMunicipalServicos" && this.model.tipFornecedor === 'F' ){
        return false;
      }      
      else {
        return true;
     }
    },

    getSituacaoPorDoc(chave){
      if(chave === 'Trabalhista'){
        return this.enums.situacaoDoc.filter(x => x.chave !== 'SemSituacao' && x.chave !== 'Positiva');
      }else if( chave === 'Municipal' || chave === 'FazendaFederalEINSS' || chave === 'Estadual'){
        return this.enums.situacaoDoc.filter(x => x.chave !== 'SemSituacao');
      }else{
        return this.enums.situacaoDoc;
      }
    },
    
    // Verifica se possui erro de validação nos campos de um documento, através das rules definidas nos componentes
    verificaErro(valida,chave){
      if(valida){
        if(this.obrigatoriedadeDocumento(chave)){
          //Define o nome dos refs utilizados para cada tipo de campo do documento 
          const textRef = `text_${chave}`;
          const dateRef = `date_${chave}`;
          const selectRef = `select_${chave}`;
          const uploadRef = `upload_${chave}`;

          let temErro = false;

          //Verifica se tem erro em campos tipo v-text-field
          if(this.$refs[textRef] != undefined){
            this.$refs[textRef].forEach(element => {
             temErro = temErro || element.hasError;
            });
          }

          //Verifica se tem erro em campos tipo datePicker
          if(this.$refs[dateRef] != undefined){
            this.$refs[dateRef].forEach(element => {
             temErro = temErro || element.$refs['date_field'].hasError;
            });
          }

          //Verifica se tem erro em campos tipo UploadFile
          if(this.$refs[uploadRef] != undefined){
            this.$refs[uploadRef].forEach(element => {
              temErro = temErro || element.$refs["campoText"].hasError;
            });
          }

          // Verifica se tem erro em campos tipo v-select
          if(this.$refs[selectRef] != undefined){
            this.$refs[selectRef].forEach(element => {
              temErro = temErro || element.hasError;
            });
          }

          return temErro;
        }
      }

    },
    
    //Verificar se Cartão CNPJ foi atualizado
    cartaoCNPJAtualizado() {
      const cnpjDoc = this.tipoDocumento['CNPJ'];      
    
      if (!cnpjDoc) {      
        return false;
      }
      
      var temArquivo = cnpjDoc.arquivoUpload && 
                      cnpjDoc.arquivoUpload !== "Não Encontrado";
      var temData = cnpjDoc.dtEmissao && 
                    cnpjDoc.dtEmissao !== null &&
                    cnpjDoc.dtEmissao !== '';
      
      var atualizado = temArquivo && temData;      
      
      return atualizado;
    },
        
    // NOVO MÉTODO: Scroll suave para Cartão CNPJ
    scrollToCartaoCNPJ() {
      this.$nextTick(() => {
        // Tentar múltiplas estratégias de scroll
        var cnpjElement = document.querySelector('[data-documento="CNPJ"]');
        
        if (cnpjElement) {
          // Estratégia 1: Scroll suave
          cnpjElement.scrollIntoView({ 
            behavior: 'smooth', 
            block: 'center' 
          });
          
          // Estratégia 2: Abrir box do CNPJ se estiver fechado
          var cnpjKey = 'CNPJ1'; // Valor padrão do enum
          if (!this.isShow[cnpjKey]) {
            this.$set(this.isShow, cnpjKey, true);
            
            // Aguardar animação de abertura
            setTimeout(() => {
              cnpjElement.scrollIntoView({ 
                behavior: 'smooth', 
                block: 'center' 
              });
            }, 300);
          }
        } 
      });
    },
    
    // Método para detectar atualização do CNPJ
    alteracaoValorCampo(tipoDocumento) {
      tipoDocumento.regularidadeFiscTrabSituacao = null;
      tipoDocumento.dtRejeicao = null;
      tipoDocumento.idMotivoIndeferimentoArquivo = null;

      // === NOVA VALIDAÇÃO: APENAS EM PROCESSOS DE ALTERAÇÃO ===
      var isCadastrador = false;

      // Só tenta chamar se o helper existir
      if (this.$verificaPerfilCadastrador && typeof this.$verificaPerfilCadastrador === 'function') {
        try {
          isCadastrador = this.$verificaPerfilCadastrador() === true;
        } catch (e) {        
          isCadastrador = false;
        }
      }

      // Se NÃO é alteração ativa E também NÃO é cadastrador  não faz nada
      if (!isCadastrador && (!this.isAlteracao || this.acaoTela !== 'alterar')) {     
        return; 
      }

      // === DETECTAR ATUALIZAÇÃO DO CNPJ ===
      if (tipoDocumento.tipDocumento === 1) { // Código do CNPJ       
        this.$nextTick(() => {
          var timestamp = Date.now();

          // Marcar que CNPJ foi atualizado
          this.contratoSocialFoiAlterado = false;
        
          if (this.$root && this.$root.$emit) {
            this.$root.$emit('cnpjAtualizadoAposContratoSocial', {
              atualizado: true,
              timestamp: timestamp,
              origem: 'regularidade-fiscal',
              dtEmissao: tipoDocumento.dtEmissao,
              arquivoUpload: tipoDocumento.arquivoUpload
            });
          }

          // Toast de sucesso
          if (this.$toasted) {
            this.$toasted.success('Cartão CNPJ atualizado com sucesso!', {
              duration: 3000,
              position: 'top-center'
            });
          }
        });
      }
    },
    beforeDestroy: function() {
      // Limpar listeners
      this.$root.$off('contratoSocialAlterado');
    }    
  }
};

</script>

<style scoped> /*CSS especifico do componente*/
.v-list__tile {
  height: 60px;
}

.v-list__tile__sub-title {
  font-size: 11px;
}

.v-list__tile--active {
  font-family: gothambold;
}

.v-list__tile--active .v-list__tile__title {
  color: #333;
}

.theme--light.v-subheader {
  font-family: gothambold;
  color: #10618b;
}

.tipoItem {
  padding-top: 0;
}
.boxFamilias .v-toolbar__title {
  font-size: 13px !important;
  color: #10618b;
}
</style>

<style scoped> /*CSS especifico do componente*/
.item-aprovado {
  outline: 2px solid #4caf50;
}

.item-reprovado {
  outline: 2px solid #ff8a80;
}

.boxInfoDoc {
  font-size: 11px !important;
  color: #10618b;
}

.boxInfoDoc .v-card__title {
  font-size: 13px !important;
}

/* NOVOS ESTILOS para feedback visual */
.cartao-cnpj-destaque {
  border: 2px solid #ff9800 !important;
  box-shadow: 0 0 10px rgba(255, 152, 0, 0.3) !important;
  animation: pulse-destaque 2s infinite;
}

@keyframes pulse-destaque {
  0% { box-shadow: 0 0 10px rgba(255, 152, 0, 0.3); }
  50% { box-shadow: 0 0 20px rgba(255, 152, 0, 0.6); }
  100% { box-shadow: 0 0 10px rgba(255, 152, 0, 0.3); }
}
</style>
